/**
 * Shared Home Locator base URLs for environment configs.
 * Non-prod uses STG so View Map / Find other prepopulate with `postalcode`.
 */
export const HOME_LOCATOR_BASE_URL_STG =
  'https://stg.purolator.com/en/shipping/find-shipping-centre';

/** Production Purolator.com Home Locator (EN path). */
export const HOME_LOCATOR_BASE_URL_PROD =
  'https://www.purolator.com/en/shipping/find-shipping-centre';
